import { GALLERY } from "@/lib/assets";

export const Gallery = () => {
  return (
    <section data-testid="gallery-section" className="bg-cream pt-20 md:pt-28 pb-20 md:pb-28 overflow-hidden">
      {/* Auto-scrolling photo band using every uploaded image */}
      <div className="flex w-max animate-marquee will-change-transform">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-stretch">
            {GALLERY.map((src, i) => (
              <div
                key={`${dup}-${i}`}
                data-testid={`gallery-image-${dup}-${i}`}
                className="mx-3 md:mx-4 h-[320px] md:h-[440px] w-[260px] md:w-[340px] flex-none overflow-hidden rounded-[1.5rem]"
              >
                <img
                  src={src}
                  alt="J on retreat"
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Gallery;
